import { useShift } from 'modules/shift';
import { CommentView } from './CommentView';

export const BreaksCommentView = () => {
  const { shift } = useShift();

  if (!shift) return null;

  const { breaksComment } = shift;

  if (!breaksComment) return null;

  return <CommentView comment={breaksComment} pt={1} />;
};
